const obj = {
  bg: "#F0ECE5",
  area: "rgba(182, 187, 196, 0.25)",
  side: "#161A30",
  side_button: "#31304D",
  side_sub: "#31304D",
};
export default obj;
